<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>

    <v-list
      :tile="false"
      flat
      nav
    >
      <app-bar-item>
        <v-btn
          text
          @click.prevent="goToProfile()"
        >
          Profile
        </v-btn>
      </app-bar-item>
      <v-divider class="mb-2 mt-2" />
      <app-bar-item>
        <v-btn
          text
          @click.prevent="logout()"
        >
          Log Out
        </v-btn>
      </app-bar-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'DefaultAccount',

    methods: {
      logout () {
        this.$store.commit('app/unsetTokens')
        this.$router.push({ name: 'Login' })
      },

      goToProfile () {
        this.$router.push({
          name: 'Profile',
          params: {
            id: this.$store.state.app.session.userIri.replace('/users/', ''),
          },
        })
      },
    },
  }
</script>
